import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/app/components/base-component';
import { SignatureHistory } from 'src/app/shared/models/signature-history';

@Component({
  selector: 'app-signer-history',
  templateUrl: './signer-history.component.html',
  styleUrls: ['./signer-history.component.scss']
})
export class SignerHistoryComponent extends BaseComponent {

  showMore = false
  @Input() signerHistory:SignatureHistory[] = []

  constructor() {super();}

}
